import { createTheme } from '@mui/material/styles';

// Import Costco Sans font
const costcoSansFont = new FontFace(
  'Costco Sans',
  `url(${new URL('./assets/fonts/CostcoSans-Upright-VF_wght_wdth_opsz-Web.woff', import.meta.url).href})`,
  {
    weight: '100 900',
    style: 'normal',
    display: 'block'
  }
);

// Load the font
costcoSansFont.load().then((font) => {
  document.fonts.add(font);
}).catch((error) => {
  console.warn('Failed to load Costco Sans font:', error);
});

// Centralized MUI theme for consistent light styling
export const appTheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#f5f7fa',
      paper: '#ffffff'
    },
    primary: {
      main: '#0a5',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#0058a3',
      contrastText: '#ffffff'
    },
    error: { main: '#d32f2f' },
    success: { main: '#2e7d32' },
    warning: { main: '#ed6c02' },
    info: { main: '#0288d1' },
    text: {
      primary: '#1e1e1e',
      secondary: '#4d5562'
    },
    divider: 'rgba(0,0,0,0.12)'
  },
  typography: {
    fontFamily: '"Costco Sans", "Segoe UI", Roboto, sans-serif',
    h6: { fontWeight: 600 }
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 6
        },
        containedPrimary: {
          boxShadow: 'none'
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    }
  }
});
